import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { WaterMark } from './watermark.type';
import { setWaterMark } from './watermark.store';

@Injectable({ providedIn: 'root' })
export class WatermarkService {
  constructor(private http: HttpClient, private store: Store) {}

  getWaterMark() {
    return this.http.get<WaterMark>('/security/watermark/config').pipe(
      map(data => {
        const watermark = {
          includeContent: data.includeContent,
          showMode: data.showMode,
          showOnPdf: data.showOnPdf === 'on'
        };
        this.store.dispatch(setWaterMark(watermark));
        return watermark;
      })
    );
  }
}
